<div class="feedback-btn">
    <button
        type="button"
        class="text-primary font-size-14 fw-bold bg-transparent p-0 border-0 mb-4 data-privacy-expand-toggle"
        (click)="collapse.toggle()"
        [attr.aria-expanded]="!isFeedbackFormCollapsed"
        aria-controls="schoolDistrictHelp"
    >
        <ng-content></ng-content>
    </button>
</div>

<div #collapse="ngbCollapse" [(ngbCollapse)]="isFeedbackFormCollapsed">
    <form [formGroup]="schoolUpdateForm" class="pt-4">
        <ng-container>
            <div class="row">
                <!-- School district selector -->
                <div class="col-8 w-100">
                    <p class="font-size-14 text-navy-blue fw-bold mb-2">
                        School district <span class="required-field">(Required)</span>
                    </p>
                    <p class="font-size-16 mb-2">
                        Enter your school district’s name (If you teach at a charter school, try
                        entering its name).
                    </p>
                    <ng-select
                        formControlName="schoolDistrict"
                        class="custom-dropdown gtm-profile-select-district"
                        [items]="schoolDistrictService.data$ | async"
                        [loading]="schoolDistrictService.isLoading$ | async"
                        [typeahead]="schoolDistrictService.searchTerm$"
                        [trackByFn]="schoolDistrictService.trackByFn"
                        (change)="schoolDistrictService.selectedItem$.next($event)"
                        (open)="schoolDistrictService.fetchData$.next(schoolState)"
                        (clear)="schoolDistrictService.fetchData$.next(schoolState)"
                        (scrollToEnd)="schoolDistrictService.scrolledToEnd$.next()"
                        placeholder="Enter district name"
                        bindLabel="district_name"
                        loadingText="Loading..."
                    >
                    </ng-select>
                    <p class="font-size-12 light-grey">
                        District data from Common Core of Data, via Education Data Portal v. 0.15.0,
                        Urban Institute, under
                        <a
                            href="https://opendatacommons.org/licenses/by/1-0/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            ODC Attribution License.
                        </a>
                    </p>
                </div>

                <!-- School selector-->
                <div class="col-8 w-100">
                    <p class="font-size-14 text-navy-blue fw-bold mb-2">School</p>
                    <div class="mb-2">
                        <ng-select
                            formControlName="schoolName"
                            class="gtm-profile-select-school"
                            [items]="schoolService.data$ | async"
                            [loading]="schoolService.isLoading$ | async"
                            [typeahead]="schoolService.searchTerm$"
                            [placeholder]="placeholderText$ | async"
                            [trackByFn]="schoolService.trackByFn"
                            (open)="
                                schoolService.fetchData$.next(schoolDistrict.value.district_guid)
                            "
                            (clear)="
                                schoolService.fetchData$.next(schoolDistrict.value.district_guid)
                            "
                            (change)="schoolService.selectedItem$.next($event)"
                            (scrollToEnd)="schoolService.scrolledToEnd$.next()"
                            bindLabel="name"
                        >
                        </ng-select>
                    </div>
                </div>
            </div>
        </ng-container>
    </form>

    <div class="d-flex justify-content-center">
        <button
            type="submit"
            class="btn btn-primary px-6 py-3 mt-7 fw-bold font-size-14 shadow gtm-submit-student-privacy"
            [ngClass]="{ 'btn-disabled': schoolUpdateFormInvalid }"
            [disabled]="schoolUpdateFormInvalid"
            (click)="onSubmit(); collapse.toggle()"
        >
            Submit
        </button>
    </div>
</div>
